<template>
    <div class="page-deliver-todo">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">澳門門店</div>
            <div class="breadcrumb-item">快遞統計</div>
        </div>
        <div class="card-block">
            <Form inline class="pg-form-inline">
                <FormItem>
                    <DatePicker class="no-suffix" type="date" size="small" :clearable="false" placeholder="起始日期" v-model="form.start_time" value-format="yyyy-MM-dd" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>
                <FormItem>-</FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="date" size="small" :clearable="false" placeholder="結束日期" v-model="form.end_time" value-format="yyyy-MM-dd" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>
				<FormItem>
				    <div class="pg-btn-wrap">
				        <div class="pg-btn style1" @click="handleSearch">搜索</div>
				    </div>
				</FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
            </Table>

            <div class="pg-pagger">
                <Row>
                     <Col span="11" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="13" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码
                form: {
                    start_time: '',
                    end_time: ''
                },
                isSubmiting: false,
                table: {
                    column: [
						{
                            title: '日期',
                            key: 'out_time_date',
                            align: 'center',
							sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '快遞數量',
                            key: 'count_goods',
                            align: 'center',
							sortable: true,
                            minWidth: 130
                        },
						{
                            title: '總代收費用',
                            key: 'sum_amount',
                            align: 'center',
							sortable: true,
                            minWidth: 130
                        },
                        {
                            title: '總重量',
                            key: 'sum_weight',
                            align: 'center',
							sortable: true,
                            minWidth: 160
                        }
                        
                    ],
                    data: []
                }
            };
        },
        mounted()
        {
            this.getList();
        },
        methods: {
			formatDate(datetime)
			{
			    if (!datetime) return '';
			
			    let dateTime = new Date(datetime);
			    let year = dateTime.getFullYear();
			    let month = dateTime.getMonth() + 1;
			    let date = dateTime.getDate();
			    let hour = dateTime.getHours();
			    let minute = dateTime.getMinutes();
			    let second = dateTime.getSeconds();
				let milliseconds = dateTime.getMilliseconds();
			    return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
			},
			formatNum(num)
			{
			    return num < 10 ? '0' + num : num;
			},
            getList()
            {
                let form = this.form;
				this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.dailyCount,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        start_time: this.$Utils.formatDate(form.start_time),
						end_time: this.$Utils.formatDate(form.end_time)
                    }
                }).then((res) =>
                {
					this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
                                count_goods: resData[i].count_goods,
                                out_time_date: resData[i].out_time_date,
                                sum_amount: Math.round(Number(resData[i].sum_amount)),
                                sum_weight: Number(resData[i].sum_weight).toFixed(1)
                            });
                        }

                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    }
                }).catch((err) =>
                {
                    // this.isLoading = false;
					this.isSubmiting = false;
                });
            },

            handleSearch()
            {
                if (this.form.start_time === '') {
                    this.$Utils.showTipInfo('請輸入起始時間');
                    return;
                } else if (this.form.end_time === '') {
                    this.$Utils.showTipInfo('請輸入結束時間');
                    return;
                } else if (this.form.end_time < this.form.start_time ) {
                    this.$Utils.showTipInfo('起始時間不能大於結束時間');
                    return;
                }
                this.pageIndex = 1;
                this.getList();
            },

            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "dailyCount.scss";
</style>